import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

// Hearts API
export const submitHeart = async (data) => {
  const response = await api.post('/hearts/submit', {
    pseudo: data.pseudo,
    email: data.email,
    heart_number: data.heartNumber,
    close_photo_path: data.closePhotoPath,
    context_photo_path: data.contextPhotoPath,
    latitude: data.latitude,
    longitude: data.longitude,
    location_name: data.locationName,
    device_id: data.deviceId,
    verified_by_ai: data.verifiedByAI || false,
  });
  return response.data;
};

export const getHearts = async () => {
  const response = await api.get('/hearts');
  return response.data;
};

export const getHeart = async (number) => {
  const response = await api.get(`/hearts/${number}`);
  return response.data;
};

export const checkHeart = async (number) => {
  const response = await api.get(`/hearts/check/${number}`);
  return response.data;
};

// AI: Detect heart number from photo
export const detectNumber = async (photoPath) => {
  const response = await api.post('/detect-number', { photo_path: photoPath });
  return response.data;
};

// AI: Validate context photo (heart in environment)
// Stats API
export const getStats = async () => {
  const response = await api.get('/stats');
  return response.data;
};

// Leaderboard API
export const getLeaderboard = async () => {
  const response = await api.get('/leaderboard');
  return response.data;
};

// Explorer profile API
export const getExplorer = async (deviceId) => {
  const response = await api.get(`/explorer/${deviceId}`);
  return response.data;
};

// File upload
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Get file URL
export const getFileUrl = (path) => {
  if (!path) return null;
  return `${API}/files/${path}`;
};

export default api;
